import React, { useState } from 'react'
import styled from 'styled-components'
import CalendatDay from '../../../../../generic/icons/IconLib/CalendarIcon'
import PalletIcon from '../../../../../generic/icons/IconLib/PalletIcon'
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon'
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon'
import UserIcon from '../../../../../generic/icons/IconLib/UserIcon'
import { IPackagesItem } from '../../../../../modules/API/Defaults/models/packages'
import { IPalletDetailes, IPalletListWithDetails } from '../../../../../modules/API/Pallets/models/palletList'
import { convertToDate } from '../../../../../modules/convertDateString'
import PalletDetailesItem from './PalletDetailesItem'
import TitleLayout from '../generic/TitleLayout'
import TitleRow from '../generic/TitleRow'
import TitleRowItem from '../generic/TitleRowItem'
import { SwipeableListItem } from '../../../../../generic/swipe/SwipeableListAdapter'
import SwipeContent from '../../knisot/Components/SwipeContent'
import { useTranslation } from 'react-i18next'

interface IPalletItem extends IPalletListWithDetails {
    isSelected?: boolean,
    index: number,
    handleSelectPallet: (index: number, palletNum: number) => void,
    packageHash?: Record<number, IPackagesItem>,
    isDisabled?: boolean,
    addProduct: (pallet: number) => void;
    activeTab?: string
    handleSelectProduct?: (item: IPalletDetailes) => void
    deleteProduct: (palletNum: number, recId: number) => void
    isAllowToEdit: boolean,
    InvoiceSale?: number
    printPallet?: (palletNum: number) => void
}
interface IMainWrapper {
    isSelected?: boolean
}
interface IDetailesWrapper extends IMainWrapper {
    $isEmpty?: boolean,
    $isOpen?: boolean
}
const PalletItem = ({
    Pallet_Num, index, handleSelectPallet, isDisabled,
    Pallet_Date, Details, packageHash, Customer_Name, InvoiceSale,
    addProduct, activeTab, handleSelectProduct, deleteProduct, isAllowToEdit,
    printPallet
}: IPalletItem) => {
    const [t] = useTranslation("teudot");
    const [move, setMove] = useState(false);
    const handleClick = () => {

        if (isDisabled) return
        setMove(true)
        try {
            setTimeout(() => {
                handleSelectPallet(index, Pallet_Num)
            }, 500)
        } catch (err) {
            setMove(false)
        }
    }
    const handleAddProduct = (e: React.MouseEvent) => {
        e.stopPropagation()
        addProduct(Pallet_Num)
    }

    const handlePrint = (e: React.MouseEvent) => {
        e.stopPropagation()
        printPallet?.(Pallet_Num)
    }

    const isExistInvoice = Details.some(item => item.InvoiceSale !== 0 || item.InvoiceBuy !== 0)
    const formatedDate: string = convertToDate(Pallet_Date)
    const detailesProps = {
        packageHash: packageHash,
    }
    return (
        
        <MainWrapper
            $move={move}
        >
        <SwipeableListItem
            swipeLeft={{
                content: <SwipeContent 
                    text={activeTab === t("teudot_create_page_tabs_taken") 
                        ? t("teudot_create_page_element_swipe_cancel") 
                        : t("teudot_create_page_element_swipe_take")
                    }
                    position='right' 
                 />,
                action: handleClick
            }}
            blockSwipe={!isAllowToEdit || (!!InvoiceSale && InvoiceSale !== 0) || isExistInvoice }
            threshold={0.35}
        >
            <TitleLayout
                isDraggable
                disableShadow
            >
                {
                    isAllowToEdit && (
                        <SideWrapper
                            onClick={handleAddProduct}
                        >
                            <PlusIcon />
                        </SideWrapper>
                    )
                }
                {
                    printPallet && (
                        <PrintSideWrapper
                            onClick={handlePrint}
                            aria-label="הדפסת משטח"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && handlePrint(e as any)}
                        >
                            <PrintIcon />
                        </PrintSideWrapper>
                    )
                }
                <TitleRow>
                    <TitleRowItem name={Customer_Name?.trim()} icon={<UserIcon />} />
                </TitleRow>
                <TitleRow>
                    <TitleRowItem name={`${formatedDate}`} icon={<CalendatDay />} />
                    <TitleRowItem name={`${Pallet_Num}`} icon={<PalletIcon />} />
                </TitleRow>
                <DetailesWrapper
                    $isEmpty={Details.length === 0}
                    $isOpen={Details.length !== 0}
                >
                    {
                        Details.map(item =>
                            <PalletDetailesItem
                                key={item.RecID} 
                                {...item} 
                                {...detailesProps} 
                                item={item} 
                                handleSelectProduct={handleSelectProduct}
                                deleteProduct={deleteProduct}
                                isAllowToEdit={isAllowToEdit}
                            />
                        )
                    }
                </DetailesWrapper>
            </TitleLayout>
            </SwipeableListItem>

        </MainWrapper>

    )
}

export default React.memo(PalletItem)

const MainWrapper = styled.div<{ $move: boolean }>`
    position: relative;
    width: 100%;
    div{
        border-radius: 20px;

    }
    -webkit-filter: drop-shadow(4px 3px 3px rgba(41,127,118,0.51));
        filter: drop-shadow(4px 3px 3px rgba(41,127,118,0.51));
    transition: all 0.5s ease-in;
    transform: ${props => props.$move ? 'translate(-110%)' : 'translate(0)'};
`

const DetailesWrapper = styled.div<IDetailesWrapper>`
    width: 100%;
    border-radius: 20px;
    max-height: ${props => props.$isEmpty ? '0' : '8.5em'};
    background: #eff3f4;
    display: ${props => props.$isOpen ? 'flex' : 'none'};
    flex-flow: column;
    padding: 0.5em;
    gap: 0.5em;
    overflow: auto;
    transition: 0.5s;
    &::-webkit-scrollbar {
        width: 0;
    }
`

const SideWrapper = styled.div`
    position: absolute;
    top: 0.5em;
    left: 0.5em;
    width: 3em;
    height: 3em;
    display: flex;
    justify-content: center;
    gap: 0.5em;
    align-items: center;
    color: #297F76;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease-in;
    &:hover {
        color: #7ab0ab;
    }
`

const PrintSideWrapper = styled.div`
    position: absolute;
    top: 0.5em;
    left: 3em;
    width: 3em;
    height: 3em;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #297F76;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease-in;
    &:hover {
        color: #7ab0ab;
    }
`
